/**
 * Generates a deterministic hash using djb2 algorithm
 * Edge Runtime compatible (no async operations required)
 *
 * @param input - String to hash
 * @returns Hex string of the hash
 */
export const djb2Hash = (input: string): string => {
  const INITIAL_HASH = 5381;
  let hash = INITIAL_HASH;

  for (let i = 0; i < input.length; i++) {
    hash = (hash << 5) + hash + input.charCodeAt(i);
  }

  // Convert to unsigned and then to hex
  return (hash >>> 0).toString(16);
};

/**
 * Generates a cache key for token validation caching
 */
export const generateTokenCacheKey = (jwt: string): string =>
  `token:${djb2Hash(jwt)}`;
